export const CLASSIFICATION_META = {
  "reported fact": { key: "fact", label: "reported fact" },
  fact: { key: "fact", label: "reported fact" },
  interpretation: { key: "interpretation", label: "interpretation" },
  assumption: { key: "assumption", label: "assumption" },
  "causal claim": { key: "causal", label: "causal claim" },
  prediction: { key: "prediction", label: "prediction" },
  uncertainty: { key: "uncertainty", label: "uncertainty" },
  preference: { key: "preference", label: "preference" },
  "value judgment": { key: "value", label: "value judgment" },
  hearsay: { key: "hearsay", label: "hearsay" },
};

export const tagColor = (classification) => {
  const meta = CLASSIFICATION_META[(classification || "").toLowerCase()] || { key: "fact" };
  return `hsl(var(--tag-${meta.key}))`;
};

export const confidenceMeta = (c) => {
  const v = (c || "").toLowerCase();
  if (v === "high") return { label: "High confidence", dots: 3 };
  if (v === "moderate") return { label: "Moderate confidence", dots: 2 };
  return { label: "Low confidence", dots: 1 };
};

export const timeAgo = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
};
